import { ILeafletMaker } from 'types/interfaces';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ReactComponent as IcMarcador } from 'resources/icons/Ic_Location_Gray.svg';
import { useEffect, useMemo, useState, useRef } from 'react';
import { Marker, useMap } from 'react-leaflet';
import { divIcon } from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { useNominatim } from 'hooks/useNominatim/useNominatim';
import { mapMarKerSelectedTypeState } from 'redux/slices/mapSlice';
import { useSelector } from 'react-redux';
import 'resources/styles/components/commons/locationmarker.scss';
import { TYPES_MARKERS } from 'utils/constants';

export default function LeafletMaker(props: ILeafletMaker) {
  const markerRef = useRef<any>(null);
  const [position, setPosition] = useState(props.position);
  const [selected, setSelected] = useState(props.selected ?? false);
  const { getNominatimReverse } = useNominatim();
  const selectorTypeMarkerSelected = useSelector(mapMarKerSelectedTypeState);
  const map = useMap();

  const marker = useMemo(() => {
    setPosition(props.position);
    setSelected(props.selected ?? false);

    return props.content ? (
      <Marker
        ref={markerRef}
        position={position}
        icon={divIcon({
          className: selected ? 'selected' : '',
          html: ReactDOMServer.renderToString(props.content),
          iconAnchor: props.iconAnchor !== undefined ? props.iconAnchor === null ? undefined : props.iconAnchor : [10, 30],
        })}
        eventHandlers={{
          click: (event: any) => {
            props.onClick && props.onClick(event);
            setSelected(true);
            map.flyTo(position, props.flyZoom);
          },
          dragend:(e:any)=>{
            getNominatimReverse({lat:e?.target?._latlng.lat, lng: e?.target?._latlng.lng});
          }
        }}
        draggable={TYPES_MARKERS.NOMINATIM === selectorTypeMarkerSelected}
      >
        {props.popUp && props.popUpElement && props.popUpElement}
      </Marker>
    ) : (
      <Marker position={position}>
        <SvgIcon Icon={IcMarcador} />
      </Marker>
    );
  }, [props.position, props.selected, selected]);

  useEffect(() => {
    props.flyZoom && map.flyTo(position, props.flyZoom);
    const markerR = markerRef.current;
    if (markerR && props.selected) {
      markerR.openPopup();
    } else {
      markerR.closePopup();
    }
  }, [props.selected]);

  return <>{marker}</>;
}
